import { useId } from 'react';

// Emerald "Single drawstring bag · Team 1/2" (393:110 / 393:113, as drawn in
// the board's scoreboard 474:36 / 474:38): the Figma path at its 22.4 x 25.15
// size, filled with the team's gradient.
const BAG_PATH =
  'M5.60087 1.5088C7.09442 0.167647 8.77467 0.167647 10.6416 1.5088C12.5085 0.167647 14.3755 0.167647 16.2424 1.5088L14.5622 6.03517H7.28111L5.60087 1.5088ZM6.72103 7.04103C4.4807 10.5616 -1.12012 18.1055 0.560128 21.626C1.68029 25.6495 20.7231 25.6495 21.8432 21.626C23.5235 18.1055 17.9227 10.5616 15.6823 7.04103H6.72103Z';

const STOPS = {
  team1: [
    ['0', 'var(--spades-grad-gold-1)'],
    ['0.24', 'var(--spades-grad-gold-2)'],
    ['0.52', 'var(--spades-grad-gold-3)'],
    ['1', 'var(--spades-grad-gold-4)'],
  ],
  team2: [
    ['0', 'var(--spades-grad-pink-1)'],
    ['0.25', 'var(--spades-pink-light)'],
    ['0.58', 'var(--spades-pink)'],
    ['1', 'var(--spades-pink-dark)'],
  ],
} as const;

interface BagIconProps {
  team: 'team1' | 'team2';
}

function BagIcon({ team }: BagIconProps) {
  // Unique per instance: both teams' bags share a page.
  const id = `bag-${useId().replace(/:/g, '')}`;
  return (
    <svg
      data-testid={`${team}-bag-icon`}
      aria-hidden="true"
      width="22.4"
      height="25.15"
      viewBox="0 0 22.4033 25.1465"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <defs>
        <linearGradient
          id={id}
          x1="11.2017"
          y1="0.502934"
          x2="11.2017"
          y2="24.6436"
          gradientUnits="userSpaceOnUse"
        >
          {STOPS[team].map(([offset, color]) => (
            <stop key={offset} offset={offset} style={{ stopColor: color }} />
          ))}
        </linearGradient>
      </defs>
      <path d={BAG_PATH} fill={`url(#${id})`} />
    </svg>
  );
}

export default BagIcon;
